import { FormField, FormFieldsCategory } from 'theSource/types';
import {
  ADDRESS_FIELDS,
  MEDICARE_FIELDS,
  VERIFICATION_FIELDS,
  QMCSO_BENEFITS_FIELDS,
} from './constants';

export const getFilteredCategories = (
  categories: FormFieldsCategory[],
  livesAtHome: boolean,
  enrollInMedicare: boolean,
  isVerified: boolean
) => {
  const filteredCategories = categories.map((category) => ({
    ...category,
    fields: category.fields.filter((field) =>
      getIsFieldVisible(field, livesAtHome, enrollInMedicare, isVerified)
    ),
  }));

  return filteredCategories;
};

function getIsFieldVisible(
  field: FormField,
  livesAtHome: boolean,
  enrollInMedicare: boolean,
  isVerified: boolean
) {
  if (ADDRESS_FIELDS.includes(field.fieldName)) {
    return !livesAtHome;
  }
  if (MEDICARE_FIELDS.includes(field.fieldName)) {
    return enrollInMedicare;
  }
  if (VERIFICATION_FIELDS.includes(field.fieldName)) {
    return isVerified;
  }
  if (QMCSO_BENEFITS_FIELDS.includes(field.fieldName)) {
    return false;
  }
  return true;
}
